// Utworzenie nowego wątku czatu

import { orionAxios } from '../orionApi';
import { CreateThreadRequest } from './orionTypes';

/**
 * Tworzy nowy wątek czatu
 * @param data - kontekst wątku (informacje o użytkowniku, stronie, języku)
 * @returns UUID nowego wątku jako string
 */
export const createThread = async (data: CreateThreadRequest): Promise<string> => {
  const response = await orionAxios.post<string>('/api/aiassistant/new-thread', data);
  return response.data;
};

